import React from 'react';
import '../pages/Hotels.css';

import Hots from '../pages/Hots'
import Holla from '../pages/Holla'
const Hotels = () => {
  return (
    <>
   <Hots />
    <section className="video-section678">
      <video className="background-video678" autoPlay loop muted>
        <source src="https://player.vimeo.com/external/454306056.sd.mp4?s=b619ef1cec555787229e2819c315a5070057b7aa&profile_id=164&oauth2_token_id=57447761" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div className="content245">
      <h1 id="opp">𝗢𝘃𝗲𝗿 𝟭𝟱𝟳,𝟬𝟬𝟬 𝗵𝗼𝘁𝗲𝗹𝘀 𝗮𝗻𝗱 𝗵𝗼𝗺𝗲𝘀 𝗮𝗰𝗿𝗼𝘀𝘀 𝟯𝟱 𝗰𝗼𝘂𝗻𝘁𝗿𝗶𝗲𝘀</h1>

        <p id="oopp">"Discover comfort and luxury at OYO hotels across India now!"</p>
      </div>
    </section>
    
    <Holla />
    <Holla />
    <Holla />
    <Holla />
    <Holla />
    <Holla />
    <Holla />

<Holla />
    </>
  )
}

export default Hotels;
